import { AnaColumn } from "../forms-template.service";

export const posizioniRifiuto: AnaColumn[] = [

    {
      itemType: "group", colCount: "1", data: [
        { type: 'campo', dataField: "id", dataType: "", caption: "Codice", width: "40", hideOnEdit: true, },
  
        { type: 'campo', dataField: "descrizione", dataType: "", caption: "Descrizione", width: "300" },
  
  
       /*  { type: 'campo', dataField: "versione", colVisible: false, hideOnEdit: true, dataType: "" },
   */
      ]
    },
  ]